angular.module('logbook')
.config(['$provide', function($provide) {
  $provide.decorator('$templateRequest', ['$delegate', function($delegate) {

    var fn = $delegate;

    $delegate = function(tpl) {

      for (var key in fn) {
        $delegate[key] = fn[key];
      }

      // the "true" parameter here suppresses template load errors
      return fn.apply(this, [tpl, true]);
    };

    return $delegate;
  }]);
}]);